import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../config/authaxios";

const initialState = { status: null, data: [], loading: false, message: '' };

export const LinkCategoryAction = createAsyncThunk(
  "link-category",
  async (data = null, { rejectWithValue }) => {
    try {
      const response = await axios.post(`/admin/link/product-with-category`, {
        ...data,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const linkCategorySlice = createSlice({
  name: "link-category",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(LinkCategoryAction.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(LinkCategoryAction.fulfilled, (state, action) => {
      state.loading = false;
      state.message = action.payload?.message;
      state.status = action.payload.status_code;
      if(state.status==401){
        localStorage.clear()
      }
      state.data = action.payload?.response;
    });
    builder.addCase(LinkCategoryAction.rejected, (state, action) => {
      state.loading = false;
      state.message = action.payload?.message;
      state.status = action.payload.status_code;
      state.error = action.error.message;
    });
  },
});

export const linkCategoryReducer = linkCategorySlice.reducer;
